import getTransactionAccountAndPurseHashes from '../../../utils/get-transaction-account-and-purse-hashes';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'typesafe-actions';
import { useMatchMedia } from '@make-software/cspr-design';
import { useGetPaginatedDeploys } from '../../../hooks/event-store-hooks';
import {
  ActivityFeedList,
  FeedAdsBanner,
  TileLayout,
} from '../../../components';
import { TrendingContracts } from './TrendingContracts';
import RandomValidatorsTile from './RandomValidatorsTile';
import { SectionPaginationType } from '../../../components/section-table/section-table-pagination';
import { AccountDataProvider } from '../../../services/account-data-service';
import { FeaturedContracts } from './FeaturedContracts';

const HomeSceneLayout = () => {
  const { selectedCurrency: currency } = useSelector(
    (state: RootState) => state.currencies
  );

  const deploysData = useGetPaginatedDeploys({
    includes: `rate(${currency.id}),contract_entrypoint,contract_package,account_info,centralized_account_info,token_market_data(${currency.id})`,
  });

  const screenType = useMatchMedia(['mobile', 'tablet', 'desktop'], []);
  const isTabletOrMobile = screenType !== 'desktop';

  const accountAndPurseHashes = getTransactionAccountAndPurseHashes(
    deploysData.data
  );

  return (
    <TileLayout
      side={[
        isTabletOrMobile ? <FeedAdsBanner key={'home-ads-banner'} /> : null,
        <FeaturedContracts key={'featured-contracts'} />,
        <RandomValidatorsTile key={'random-validators'} />,
        <TrendingContracts key={'trending-apps'} />,
      ]}
    >
      <AccountDataProvider accountAndPurseHashes={accountAndPurseHashes}>
        <ActivityFeedList
          data={deploysData.data}
          loading={deploysData.loading}
          error={deploysData.error}
          paginationProps={deploysData.paginationProps}
          paginationType={SectionPaginationType.extendedPagination}
          showViewAllLink
        />
      </AccountDataProvider>
    </TileLayout>
  );
};

export default HomeSceneLayout;
